import { combineReducers } from 'redux'

import getSettingReferral from './getSettingReferral'
import updateSettingReferral from './updateSettingReferral'

export default combineReducers({
  getSettingReferral,
  updateSettingReferral
})
